import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';

class Guilds extends Component {
    constructor(props) {
        super(props);

        this.state = {
            guilds: [],
        };

        this.fetchGuilds();
    }

    async fetchGuilds() {
        let guilds = await this.props.ethereum.guilds.getGuildsForUser();
        this.setState({guilds: guilds});
    }

    leaveGuild() {
        if (!window.confirm("Are you sure you want to leave this guild?")) {
            return;
        }
        this.props.ethereum.guilds.leaveGuild(this.props.selectedGuild);
        let guilds = [... this.state.guilds];
        let index = guilds.indexOf(this.props.selectedGuild);
        guilds.splice(index, 1);
        this.setState({guilds: guilds});
        this.props.onClickGuild(this.props.selectedGuild);
    }

    renameGuild() {
    }

    render() {
        if (this.state.guilds.length === 0) {
            return (
                <div></div>
            );
        }

        return (
            <div className="guilds">
              <div className="linked-count">
                And <span className="linked-count-number">
                  {this.state.guilds.length}</span> guilds</div>
              {this.state.guilds.map(
                  guild =>
                      <Guild
                        selected={guild.guildId === this.props.selectedGuild}
                        onClickGuild={() => this.props.onClickGuild(guild.guildId)}
                        guild={guild}/>)}
                <ConditionedComponent condition={this.props.selectedGuild}>
                <div className="guild-action-buttons">
                <div
                  onClick={() => this.leaveGuild()}
                  className="guild-action-button common-button pink-button">Leave Guild</div>
                <div
                  onClick={() => this.renameGuild()}
                  className="guild-action-button common-button pink-button">Rename Guild</div>
                </div>
                </ConditionedComponent>
            </div>
        );
    }
}

class Guild extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let className = this.props.selected ? "guild selected" : "guild";
        return (
            <div
              onClick={this.props.onClickGuild}
              className={className}>
              <div className="linked-user-name">
                {this.props.guild.name === '' ? this.props.guild.guildId :
                this.props.guild.name}</div>
            </div>
        );
    }
}

export default Guilds;
